import React from "react";
import { FormattedMessage } from "react-intl";
import injectIntl from "Util/injectIntl";
import type { WithIntlProps } from "Util/injectIntl";

const InjectMessage = ({
  intl: _intl,
  ...props
}: React.ComponentProps<typeof FormattedMessage> & WithIntlProps) => (
  <FormattedMessage {...props} />
);

export default injectIntl(InjectMessage);
